module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageDesert/DIGITAL_CAMOUFLAGE_DESERT_czech.6c073419.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageDesert/DIGITAL_CAMOUFLAGE_DESERT_czech.png
// module id = 1218
// module chunks = 16